import { render, staticRenderFns } from "./ui-checkbox.vue?vue&type=template&id=27450041&lang=pug&"
import script from "./ui-checkbox.vue?vue&type=script&lang=js&"
export * from "./ui-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27450041')) {
      api.createRecord('27450041', component.options)
    } else {
      api.reload('27450041', component.options)
    }
    module.hot.accept("./ui-checkbox.vue?vue&type=template&id=27450041&lang=pug&", function () {
      api.rerender('27450041', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-pages/ui-checkbox.vue"
export default component.exports